import useMediaQuery from '@mui/material/useMediaQuery';

const ReducedMotionQuery = '(prefers-reduced-motion: reduce)';

/**
 * Reports whether the user asked the system for less motion, so busy
 * indicators can drop their animation and rely on text instead.
 *
 * Environments without `matchMedia` (jsdom, WebView2 edge cases) answer
 * "no preference", which keeps the animated default.
 */
export function usePrefersReducedMotion(): boolean {
  return useMediaQuery(ReducedMotionQuery, { defaultMatches: false });
}
